// src/themes/light.ts
import { DefaultTheme } from 'styled-components'

const temaLight: DefaultTheme = {
  corPrincipal: '#000',
  corSecundaria: '#555',
  corDeFundo: '#f5f5f5',
  corDeFundoBotao: '#4d45beff',
  corDaBorda: '#4d45beff'
}

export default temaLight
